import { makeStyles, Spinner, tokens } from "@fluentui/react-components";
import {
  FolderZip24Regular,
  ArrowDownload24Regular,
} from "@fluentui/react-icons";
import { IOrder } from "../../interfaces/IOrder";
import { useTranslation } from "react-i18next";
import { DataContext } from "../../context/DataContext";
import { useContext } from "react";
import dayjs from "dayjs";
import { ApiContext } from "../../Root";
import { useAuth } from "../../authentication/AuthContextProvider";
const useStyles = makeStyles({
  container: {
    display: "flex",
  },
  order: {
    fontWeight: tokens.fontWeightSemibold,
    lineHeight: tokens.lineHeightBase300,
    fontSize: tokens.fontSizeBase300,
    marginLeft: tokens.spacingHorizontalXL,
  },
  text: {
    fontWeight: tokens.fontWeightRegular,
    lineHeight: tokens.lineHeightBase300,
    fontSize: tokens.fontSizeBase300,
  },
  details: {
    marginLeft: tokens.spacingHorizontalMNudge,
  },
  lastModified: {
    color: "#666666",
    marginLeft: tokens.spacingHorizontalXL,
  },
  customerOrderNumber: {
    marginLeft: tokens.spacingHorizontalXL,
    fontStyle: "italic",
    color: "#666666",
  },
  wrapper: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
  },
  folderZip: {
    marginTop: tokens.spacingVerticalXS,
  },
  icon: {
    marginTop: tokens.spacingVerticalSNudge,
    marginRight: tokens.spacingHorizontalXS,
  },
  download: {
    cursor: "pointer",
  },
  disabled: {
    color: tokens.colorNeutralForegroundDisabled,
  },
});

type ItemProps = {
  order: IOrder;
};
export const Item = ({ order }: ItemProps): JSX.Element => {
  const styles = useStyles();
  const dataContext = useContext(DataContext);
  const { folderIsDownLoading } = dataContext.state;
  const apiClient = useContext(ApiContext);
  const { customerOrderApi } = apiClient;
  const auth = useAuth();
  const { t } = useTranslation();
  return (
    <div className={styles.container}>
      <FolderZip24Regular className={styles.folderZip} />
      <div className={styles.wrapper}>
        <div>
          <div>
            <strong className={styles.order}> {order.orderNumber}</strong>
            <text className={`${styles.text} ${styles.details}`}>
              {order.address}
            </text>
          </div>
          <text className={`${styles.text} ${styles.customerOrderNumber}`}>
            {order.customerOrderNumber ?? <i>Inget kundordernummer</i>}
          </text>
          <text className={`${styles.text} ${styles.lastModified}`}>
            {dayjs(order.modified).format("YYYY-MM-DD HH:mm")}
          </text>
        </div>
        <div>
          {folderIsDownLoading === order.id ? (
            <Spinner size="extra-small" />
          ) : (
            <ArrowDownload24Regular
              className={`${order.isConfidential ? styles.disabled : styles.download} ${styles.icon}`}
              onClick={async () => {
                if (!order.isConfidential) {
                  await customerOrderApi.downloadFolder(
                    dataContext,
                    auth.user,
                    order.id,
                    order.orderNumber,
                    t
                  );
                }
              }}
            />
          )}
        </div>
      </div>
    </div>
  );
};
